import { AxiosRequestConfig } from 'axios';
import instance from 'api';
import { IKSKDebtModel } from 'interfaces';
import { downloadFile } from 'helper';
import {
  IUsoDebtSearchResult,
  IUsoDebtByKontragent,
  IUsoDebtByRoom,
  IUsoOwner,
} from './interfaces';

/** Старая ручка — загрузка долга по паре (помещение, владелец) */
export const getKSKDebt = (apartmentGuid: string, kontragentGuid: string) => {
  return instance()
    .post<IKSKDebtModel>('/application/getDebtKSK', { apartmentGuid, kontragentGuid })
    .then((response) => response.data);
};

/** Старая ручка — акт сверки PDF */
export const downloadDebtActPdf = (params: {
  realEstateGuid: string;
  contractGuid: string;
  ownerGuid1c: string;
}) => {
  return instance()
    .post('/defectAct/debtActFileLoad', params, { responseType: 'blob' })
    .then((response) => {
      downloadFile(response.data, 'application/pdf;charset=UTF-8', 'Акт сверки.pdf', false);
    });
};

/** Поиск контрагентов по ФИО/ИИН/БИН (без дублей) */
export const findOwners = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IUsoOwner[]>('/application/uso/debt/findOwners', config)
    .then((response) => response.data);
};

/** Поиск по номеру помещения (совместимо с AsyncSearch.fetch) */
export const findByRoom = (config?: AxiosRequestConfig) => {
  return instance()
    .get<IUsoDebtSearchResult[]>('/application/uso/debt/findByRoom', config)
    .then((response) => response.data);
};

/** Детализация долга по контрагенту */
export const getDebtByKontragent = (
  kontragentGuid: string,
  dateFrom?: string,
  dateTo?: string,
) => {
  return instance()
    .get<IUsoDebtByKontragent[]>('/application/uso/debt/getByKontragent', {
      params: { kontragentGuid, dateFrom, dateTo },
    })
    .then((response) => response.data);
};

/** Детализация долга по помещению */
export const getDebtByRoom = (
  roomGuid: string,
  dateFrom?: string,
  dateTo?: string,
) => {
  return instance()
    .get<IUsoDebtByRoom[]>('/application/uso/debt/getByRoom', {
      params: { roomGuid, dateFrom, dateTo },
    })
    .then((response) => response.data);
};

/** Скачать акт сверки по контрагенту */
export const downloadActByKontragent = (
  kontragentGuid: string,
  dateFrom?: string,
  dateTo?: string,
) => {
  return instance()
    .get('/application/uso/debt/downloadFileByKontragent', {
      params: { kontragentGuid, dateFrom, dateTo },
      responseType: 'blob',
    })
    .then((response) => {
      downloadFile(response.data, 'application/pdf;charset=UTF-8', 'Акт сверки.pdf', false);
    });
};

/** Скачать акт сверки по помещению */
export const downloadActByRoom = (
  roomGuid: string,
  dateFrom?: string,
  dateTo?: string,
) => {
  return instance()
    .get('/application/uso/debt/downloadFileByRoom', {
      params: { roomGuid, dateFrom, dateTo },
      responseType: 'blob',
    })
    .then((response) => {
      downloadFile(response.data, 'application/pdf;charset=UTF-8', 'Акт сверки.pdf', false);
    });
};
